import { parseQuery, withQuery } from 'ufo';

import { getUserManager } from './user-manager';

export function removeAuthQueryParams() {
  const currentQuery = parseQuery(window.location.search);

  return withQuery(window.location.href, {
    ...currentQuery,
    state: undefined,
    code: undefined,
    session_state: undefined,
    iss: undefined,
    error: undefined,
  });
}

export function onSigninCallback() {
  window.history.replaceState({}, '', removeAuthQueryParams());
}

export async function getIdTokenPayload() {
  const userManager = getUserManager();
  const user = await userManager.getUser();

  return user?.profile;
}

export async function getCurrentWorkspaceId() {
  const profile = await getIdTokenPayload();
  const workspaceIds = Object.keys(profile?.workspaces || {});

  return workspaceIds[0];
}

export const wsId = getCurrentWorkspaceId;

export async function getValidAccessToken() {
  const userManager = getUserManager();

  let user = await userManager.getUser();
  if (user?.expired)
    user = await userManager.signinSilent();

  return user && user.access_token;
}

export async function fetchWithTokenAndWorkspaceId(...params: Parameters<typeof fetch>) {
  const [url, options] = params;
  const optionTmp = options ? { ...options } : { method: 'GET' };

  let headers = new Headers();
  if (optionTmp.headers) {
    headers = !(optionTmp.headers instanceof Headers)
      ? new Headers(optionTmp.headers)
      : optionTmp.headers;
  }

  if (!headers.has('Accept'))
    headers.set('Accept', 'application/json');

  const accessToken = await getValidAccessToken();
  if (accessToken) {
    headers.set('Authorization', `Bearer ${accessToken}`);

    if (!optionTmp.credentials)
      optionTmp.credentials = 'same-origin';
  }

  const workspaceId = await getCurrentWorkspaceId();
  if (workspaceId) {
    headers.set('X-Workspace-Id', workspaceId);
  }

  const newOptions = { ...optionTmp, headers };
  return await fetch(url, newOptions);
}

export function getWorkspaceRolesFromIdToken(idTokenPayload: any, workspaceId: string | undefined): string[] {
  if (!workspaceId)
    return [];

  const workspaces = idTokenPayload?.workspaces || {};
  return workspaceId ? (workspaces[workspaceId]?.roles || []) : [];
}

export async function getWorkspaceRoles() {
  const [workspaceId, idTokenPayload] = await Promise.all([
    getCurrentWorkspaceId(),
    getIdTokenPayload(),
  ]);

  return getWorkspaceRolesFromIdToken(idTokenPayload, workspaceId);
}
